import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table, Input, InputNumber, Popconfirm } from 'antd';
import { Modal, Icon, Form, Button, message } from 'antd';
import { apis } from '../api';
import { instProjectInfo } from '../utils';

const EditableContext = React.createContext();

class EditableCell extends React.Component {
  static propTypes = {
    inputType: PropTypes.string,
    editing: PropTypes.bool,
    dataIndex: PropTypes.string,
    title: PropTypes.string,
    record: PropTypes.object,
    index: PropTypes.number,
    children: PropTypes.array,
  };
  getInput = () => {
    if (this.props.inputType === 'number') return <InputNumber />;
    return <Input />;
  };

  renderCell = ({ getFieldDecorator }) => {
    const { editing, title, record, children, ...restProps } = this.props;
    const { dataIndex } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [{ required: true, message: `请输入${title}!` }],
              initialValue: record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return (
      <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
    );
  }
}

class EditableTable extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    form: PropTypes.object,
    toggleProjectVisible: PropTypes.func,
  };
  constructor(props) {
    super(props);

    this.state = { list: [], editingKey: '', page: 1, pageSize: 20, total: 0 };
    this.columns = [
      {
        title: '序号',
        dataIndex: 'id',
        key: 'id',
        width: '15%',
        editable: false,
        render: (text, record, index) => {
          const { page, pageSize } = this.state;
          const num = (page - 1) * pageSize + (index + 1);
          return <span>{num}</span>;
        },
      },
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
        width: '65%',
        editable: true,
      },
      {
        title: '操作',
        dataIndex: 'id',
        key: 'oprate',
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {form => (
                  <Button
                    onClick={() => this.save(form, record.id)}
                    style={{ marginRight: 8 }}
                    size="small"
                  >
                    确定
                  </Button>
                )}
              </EditableContext.Consumer>
              <Popconfirm
                title="是否确定取消?"
                onConfirm={() => this.cancel(record.id)}
              >
                <Button size="small">取消</Button>
              </Popconfirm>
            </span>
          ) : (
            <Button
              disabled={editingKey !== ''}
              onClick={() => this.edit(record.id)}
              type="link"
              size="small"
            >
              <Icon type="edit" theme="filled" />
              修改
            </Button>
          );
        },
      },
    ];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });

      if (this.props.visible) {
        this.setState({ page: 1 });
        this.getInstProjectInfo(1);
      }
    }
  }

  getInstProjectInfo = async page => {
    const size = this.state.pageSize;
    const res = await instProjectInfo(page, size);
    this.setState({ list: res.list, total: res.total });
  };

  isEditing = record => record.id === this.state.editingKey;

  cancel = () => {
    const { editingKey } = this.state;
    if (editingKey === 'add') {
      const { list } = this.state;
      list.splice(0, 1);
    }
    this.setState({ editingKey: '' });
  };

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) return;

      const newData = [...this.state.list];
      const index = newData.findIndex(item => key === item.id);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        this.setState({ list: newData, editingKey: '' });
        const newItem = newData[index];
        if (newItem.id === 'add') {
          const post = { name: newItem.name };
          apis.addInstProject(post).then(res => {
            if (res.code === '0') {
              message.success('新增成功');
              this.setState({ page: 1 });
              this.getInstProjectInfo(1);
            } else message.error(message.error(res.message));
          });
        } else {
          const post = { id: newItem.id, name: newItem.name };
          apis.modifyInstProject(post).then(res => {
            if (res.code === '0') message.success('修改成功');
            else message.error(res.message);
          });
        }
      } else {
        this.setState({ list: newData, editingKey: '' });
      }
    });
  }

  edit(key) {
    this.setState({ editingKey: key });
  }

  add = () => {
    const { list } = this.state;
    list.splice(0, 0, { id: 'add', name: '' });

    this.setState({ editingKey: 'add', list });
  };

  handleCancel = () => {
    this.props.toggleProjectVisible();
  };

  handlePageChange = page => {
    this.cancel();
    this.setState({ page });
    this.getInstProjectInfo(page);
  };

  render() {
    const components = {
      body: { cell: EditableCell },
    };

    const columns = this.columns.map(col => {
      if (!col.editable) return col;

      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'age' ? 'number' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });

    const { visible, list, editingKey } = this.state;

    return (
      <Modal
        title="项目名称管理"
        visible={visible}
        width={'50%'}
        height={'60%'}
        ref={this.modal}
        id="modal"
        className="group-manager project-manager"
        onCancel={this.handleCancel}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={this.handleCancel}
            className="btn-ok"
          >
            确定
          </Button>,
        ]}
      >
        <div className="project-list">
          <EditableContext.Provider value={this.props.form}>
            <div className="add-project-btn">
              <div className="center">
                <Button
                  icon="plus"
                  type="link"
                  onClick={this.add}
                  disabled={editingKey !== ''}
                >
                  新增项目名称
                </Button>
              </div>
            </div>
            <Table
              components={components}
              bordered
              dataSource={list}
              columns={columns}
              rowKey={record => record.id}
              rowClassName="editable-row"
              pagination={{
                size: 'small',
                pageSize: this.state.pageSize,
                total: this.state.total,
                onChange: this.handlePageChange,
              }}
            />
          </EditableContext.Provider>
        </div>
      </Modal>
    );
  }
}

export default withRouter(Form.create()(EditableTable));
